import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";


@Component({
    selector: "confirmation.dialog.component",
    templateUrl: "./confirmation.dialog.component.html",
    styleUrls: ["./confirmation.dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConfirmationDialogComponent {
  isCheckboxChecked = false;
  showCheckbox: boolean;
  confirmMessage: string;

  constructor(public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: { confirmMessage: string; showCheckbox: boolean }
  ) {
    // Initialize confirmMessage and showcheckbox boolean
    this.confirmMessage = dialogData?.confirmMessage ?? '';
    this.showCheckbox = dialogData?.showCheckbox ?? false;
  }
  closeDialog(confirmed: boolean) {
    // If the checkbox is shown, allow confirm/cancel only if its checked
    if (this.showCheckbox && !this.isCheckboxChecked) {
      return;
    }

    this.dialogRef.close(confirmed);// Close and return the status
  }
}


